import React from 'react';
import PropTypes from 'prop-types';
import styles from './Header.module.scss';

class Header extends React.PureComponent {
  render () {
    const { title, subTitle } = this.props;

    return (<div id='pageHeader'>
      <div className={styles.title}>
        {title && title}
      </div>
      <h2 className={styles.subTitle}>
        {subTitle && subTitle}
      </h2>
    </div>
    );
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string
};

export default Header;
